import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
    selector: '[load-data-grid]',
    exportAs: 'load-data-grid',
    standalone: false
})
export class LoadDataGridDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
